import { render, staticRenderFns } from "./setPassword.vue?vue&type=template&id=f8d7db18&scoped=true"
import script from "./setPassword.vue?vue&type=script&lang=js"
export * from "./setPassword.vue?vue&type=script&lang=js"
import style0 from "./setPassword.vue?vue&type=style&index=0&id=f8d7db18&lang=scss&scoped=true"
import style1 from "./setPassword.vue?vue&type=style&index=1&id=f8d7db18&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d7db18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/3e17078e833b83b1/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8d7db18')) {
      api.createRecord('f8d7db18', component.options)
    } else {
      api.reload('f8d7db18', component.options)
    }
    module.hot.accept("./setPassword.vue?vue&type=template&id=f8d7db18&scoped=true", function () {
      api.rerender('f8d7db18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/setup/components/setPassword/setPassword.vue"
export default component.exports